import { UserStorageService } from "src/application/ports";
import { useStore } from "./store";

export function useUserStorage(): UserStorageService {
  return useStore();
}
